import { render, staticRenderFns } from "./OutpatientServices.vue?vue&type=template&id=363adcb8&scoped=true"
import script from "./OutpatientServices.vue?vue&type=script&lang=js"
export * from "./OutpatientServices.vue?vue&type=script&lang=js"
import style0 from "./OutpatientServices.vue?vue&type=style&index=0&id=363adcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363adcb8",
  null
  
)

export default component.exports